import axios from 'axios';
import store from '../src/store/store';

export default {
  install (Vue, options) {
    let instance = axios.create({
      baseURL: process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'spa/controller',
      withCredentials: true
    });
    instance.interceptors.response.use(
      function(response) {
        if(store.getters['offline/isOffline']) {
          store.dispatch('offline/setOnlineMode');
        }
        return response;
      },
      function(error) {
        /* Detailed error logging */
        // if (error.response) {
        //   // The request was made and the server responded with a status code
        //   // that falls out of the range of 2xx
        //   console.log(error.response.data);
        //   console.log(error.response.status);
        //   console.log(error.response.headers);
        // } else if (error.request) {
        //   // The request was made but no response was received
        //   // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        //   // http.ClientRequest in node.js
        //   console.log(error.request);
        // } else {
        //   // Something happened in setting up the request that triggered an Error
        //   console.log('Error', error.message);
        // }
        // console.log(error.config);
        /* Short error logging */
        console.log(error);
        /* Set application in offline mode */
        if(!store.getters['offline/isOffline']) {
          store.dispatch('offline/setOfflineMode');
        }
        return Promise.reject(error);
      }
    );
    Vue.prototype.$http = instance;
  }
}